import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-use", label: "Terms of Use" },
  { to: "/consent-to-contact", label: "Consent to Contact" },
  { to: "/do-not-sell", label: "Do Not Sell or Share" },
  { to: "/do-not-call-policy", label: "Do Not Call" },
  { to: "/contact", label: "Contact / Licensing" }
];

export default function FunnelFooter() {
  return (
    <footer className="fv2-footer">
      <div className="fv2-footer-top">
        <div className="fv2-footer-brand">FamilyHealth Plans</div>
        <nav className="fv2-footer-links">
          {LINKS.map((link) => (
            <Link key={link.to} to={link.to} className="fv2-footer-link">
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="fv2-footer-bottom">
        <p className="fv2-footer-disclaimer">
          <strong className="fv2-footer-disclaimer-label">Disclaimer:</strong>{" "}
          FamilyHealth Plans is a private insurance lead and enrollment
          assistance website. We are not HealthCare.gov and are not affiliated
          with or endorsed by any government agency or the federal Medicare
          program.
        </p>
      </div>
    </footer>
  );
}
